<template>
  <div
    v-if="secondaryBadgeLabel"
    class="z-10 inline-block px-[5px] py-[3px] text-left uppercase leading-4 md:px-[7px] md:py-[5px]"
  >
    <slot name="badgeLabelSlot">
      <span class="text-xs font-normal tracking-widest md:text-sm">
        {{ badgeLabel }}
      </span>
    </slot>
    <br />
    <slot name="badgeSecondaryLabelSlot">
      <span class="text-sm font-medium md:text-lg">
        {{ secondaryBadgeLabel }}
      </span>
    </slot>
    <slot name="badgeThirdLabelSlot">
      <span class="text-sm font-medium md:text-lg">
        {{ thirdBadgeLabel }}
      </span>
    </slot>
  </div>
  <div
    v-else
    class="text-md z-10 mt-2.5 inline-block px-[5px] py-[3px] text-center font-normal leading-4 md:px-[7px] md:py-[5px]"
  >
    {{ badgeLabel }}
  </div>
</template>

<script setup lang="ts">
defineProps({
  badgeLabel: {
    type: String as PropType<string>,
    default: null,
  },
  secondaryBadgeLabel: {
    type: String as PropType<string>,
    default: null,
  },
  thirdBadgeLabel: {
    type: String as PropType<string>,
    default: null,
  },
})
</script>
